import { createSlice } from "@reduxjs/toolkit";
import { ProjectType } from "../../Type/ProjectLayoutType";
import { PROJECT_LIST_DATA } from "../../Data/Project";

const initialState: ProjectType = {
  activeTab: "1",
  createdFormData: PROJECT_LIST_DATA,
};

const ProjectSlice = createSlice({
  name: "SideBarSlice",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setCreatedData: (state, action) => {
      state.createdFormData = action.payload;
    },
  },
});
export const { setActiveTab, setCreatedData } = ProjectSlice.actions;

export default ProjectSlice.reducer;
